import axios from "axios";
import Util from '../utils/Util'
import { getApiKeyHeaders } from '../utils/apiKey';
const BASE_API_URL = `${window?.appConfig?.API_ENDPOINT}`;

const getConfig = () => ({
  headers: getApiKeyHeaders(),
});

function uploadTemplate(requestObj) {
  return axios.post(BASE_API_URL + `/emailTemplates`, requestObj, getConfig(), {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
}

function updateTemplate(templateName, organizationId, requestObj) {
  return axios.put(
    BASE_API_URL + `/emailTemplates/` + templateName + "/" + organizationId,
    requestObj,
    getConfig(),
    {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }
  );
}

function getAllTemplates(query) {
  let queryParams = Util.buildQueryParams(query);
  return axios.get(BASE_API_URL + `/emailTemplates` + queryParams, getConfig());
}

function downloadTemplate(templateName, organizationId) {
  return axios.get(
    BASE_API_URL +
      `/emailTemplates/` +
      templateName +
      "/" +
      organizationId +
      `/download`,
    getConfig(),
    {
      headers: {
        responseType: "blob"
      }
    }
  );
}
function deleteTemplate(templateName, organizationId) {
  return axios.delete(
    BASE_API_URL + `/emailTemplates/` + templateName + "/" + organizationId,
    getConfig()
  );
}
function sendEmail(requestObj) {
  return axios.post(
    BASE_API_URL + "/emailTemplates/sendEmail",
    requestObj,
    getConfig()
  );
}

export default {
  uploadTemplate,
  updateTemplate,
  getAllTemplates,
  downloadTemplate,
  deleteTemplate,
  sendEmail
};
